/** Variables for QA environment */
export const environment = {
  // ENVIRONMENT META
  PRODUCTION: false,
  ACTUAL_ENV: 'qa',

  // API V3
  PASSWORD_TOKEN_SHA1: 'LAB4U.ZSDFQ34123A#$%.COM',
  API_V3_URL: 'https://api-qa.lab4u.co/v3',
  API_V3_KEY: 'NQyUrsKAmfZjpfRMqlAoJzJTWuBorL96',

  // MIXPANEL SERVER SIDE-TRACKING
  RELAY_URL: 'https://svcqa.lab4u.co/api/v1/relay',
  RELAY_AES_KEY: '69ed2cd6d93b10c8d08261a1f71ce803',

  // SSO
  GOOGLE_OAUTH_CLIENT_ID:
    '463801181567-ct9fsbbbkq5mvojc850qdjrb4ua907md.apps.googleusercontent.com',
  MICROSOFT_OAUTH_CLIENT_ID: '50a70bad-b521-42fa-8d78-7d05b51839a1',
};
